import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateTerminalMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateTerminal = createAsyncThunk('updateTerminal', async (payload) => {
  return await updateTerminalMasterApi(payload);
});

const updateTerminalSlice = createSlice({
  name: 'updateTerminal', // Unique Name
  initialState,
  reducers: {
    updateTerminalReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateTerminal.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateTerminal.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateTerminal.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateTerminalReset } = updateTerminalSlice.actions;

export default updateTerminalSlice.reducer;
